import React, { useState } from 'react';
import style from './ChallengeCard.module.css';
import { MdKeyboardArrowDown, MdDelete } from 'react-icons/md';
import WorkoutCard from '../WorkoutCard/WorkoutCard';

const ChallengeCard = props => {
	const [openWorkouts, setOpenWorkouts] = useState(false)

	// Normalize and clamp workoutSets to a safe, non-negative integer to avoid RangeError
	const rawSetsCount = Number(props.workoutSets)
	const setsCount = Number.isFinite(rawSetsCount) && rawSetsCount > 0
		? Math.min(100, Math.floor(rawSetsCount))
		: 0

	const showWorkouts = {
		display: openWorkouts ? 'flex' : 'none',
	};

	return (
		<div className={style.ChallengeCardWrapper}>
			<div className={style.ChallengeCard} onClick={() => setOpenWorkouts(!openWorkouts)}>
				<div className={style.ChallengeDetails}>
					<div className={style.ChallengeInfo}>
						<span className={style.ChallengeName}>{props.workoutName}</span>
						<span className={style.ChallengeNumber}>{props.workoutSets} sets, {props.workoutReps} reps</span>
						{
							props.deleteable && <span
								onClick={props.delete}
								className={style.DeleteButton}>
								<MdDelete className={style.DeleteIcon} />
								Delete
							</span>
						}
					</div>

					<MdKeyboardArrowDown
						className={style.arrow}
						onClick={() => setOpenWorkouts(!openWorkouts)}
					/>
				</div>
			</div>

			<div style={showWorkouts} className={style.WorkoutCards}>
				<div>
					<a href={`https://www.youtube.com/results?search_query=how+to+${props.workoutName}+exercise`} target='_blank' rel="noreferrer" className={style.DemoLink}>
						Demo
					</a>
				</div>
				{Array.from({ length: setsCount }, (_, index) => (
					<WorkoutCard
						key={index}
						name={props.workoutName}
						reps={props.workoutReps}
						percentagePoints={props.percentagePoints}
					/>
				))}
			</div>
		</div>
	)
}

export default ChallengeCard;